/**
 * Axios Configuration - Global Setup
 *
 * This file configures axios interceptors to automatically:
 * 1. Add authentication tokens to all API requests
 * 2. Handle authentication errors globally
 * 3. Redirect to login when unauthorized
 */

import axios from 'axios';

// Request Interceptor - Automatically adds auth token
axios.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('access_token');

    // Add Authorization header if token exists and not already set
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor - Handles auth errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - Token expired or invalid
    if (error.response?.status === 401) {
      // Clear invalid token
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');

      // Redirect to login page (only if not already there)
      if (!window.location.pathname.includes('/login')) {
        alert('Your session has expired. Please login again.');
        window.location.href = '/login';
      }
    }

    // Handle 500 Server Error
    if (error.response?.status === 500) {
      alert('Server error occurred. Please try again later.');
    }

    return Promise.reject(error);
  }
);

export default axios;
